import { render, staticRenderFns } from "./PostTraining.vue?vue&type=template&id=dd5a9624&"
import script from "./PostTraining.vue?vue&type=script&lang=js&"
export * from "./PostTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports